export default __webpack_public_path__ + "static/media/ps.3009e0c8.svg";